import * as actionTypes from "./actionTypes";
import axios from "../../axios-amps";
import { logFirebaseEvent } from "../../shared/utility";
import { serverconfigs } from "../../constants";

export const setProcedureDetails = (procedureDetails) => {
  return {
    type: actionTypes.SET_PROCEDURE_DETAILS,
    procedureDetails: procedureDetails,
  };
};
export const fetchProcedureDetailsFailed = (error) => {
  return {
    type: actionTypes.FETCH_PROCEDURE_DETAILS_FAILED,
    payload: error,
  };
};

export const fetchProcedureDetails = () => {
  return (dispatch) => {
    axios
      .get(serverconfigs.fetchProcedureDetailsUrl)
      .then((response) => {
        console.log(response.data);
        dispatch(setProcedureDetails(response.data.result));
      })
      .catch((error) => {
        if (error.statusCode === 400) {
          logFirebaseEvent("Exception400");
        } else if (error.statusCode === 401) {
          logFirebaseEvent("Exception401");
        } else if (error.statusCode === 500) {
          logFirebaseEvent("Exception500");
        }
        dispatch(fetchProcedureDetailsFailed(error));
      });
  };
};
